export default __webpack_public_path__ + "static/media/P20-Tip.bf1cc2af.svg";